export default function () {
    return {
        GROUP_DEADLINE: '{GROUP_DEADLINE}'
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/evaluation/introduction/placeholder/index.js